var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "theme-toggle",
      attrs: { type: "button", "aria-label": _vm.label, title: _vm.label },
      on: { click: _vm.toggleTheme },
    },
    [
      _c("i", {
        staticClass: "fas",
        class: _vm.isDarkTheme ? "fa-sun" : "fa-moon",
        attrs: { "aria-hidden": "true" },
      }),
      _c("span", { staticClass: "theme-toggle__text d-none d-md-inline" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }